import { LoaderCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export const Loader = ({
  className,
  visible,
}: {
  className?: string;
  visible?: boolean;
}) => {
  // const appInitialized = useRootStore((state) => state.appInitialized);
  const [render, setRender] = useState(true);

  useEffect(() => {
    if (visible) setRender(true);
    else {
      setTimeout(() => {
        setRender(false);
      }, 100);
    }
  }, [visible]);

  return (
    <>
      <LoaderCircle
        style={{
          opacity: render ? 0.8 : 0,
          transition: 'opacity 319ms ease-out',
        }}
        className={twMerge(
          'text-foreground animate-spin pointer-events-none select-none text-primary',
          className,
          // appInitialized ? 'text-primary' : '',
        )}
      />
    </>
  );
};
